import { DefaultTheme } from "styled-components"

export const LoaderTheme: DefaultTheme = {
  primaryColor: "",
  secondaryColor: "",
  textColor: "#C83732",
  backgroundColor: "#130304",
  cardBackgroundColor: "",
}
